module.exports = __webpack_public_path__ + "static/media/logo119.ae974daa.png";